module.exports = __webpack_public_path__ + "img/raffle-draw.1a8d6347.svg";